// extracted by mini-css-extract-plugin
module.exports = {"autoSliderBlock":"BZk9","header":"BZap","title":"BZal","link":"BZch","sliderWrapper":"BZk5","visible":"BZk7","nextBtn":"BZk-","prevBtn":"BZlb","disabled":"BZib"};